import { Box, CircularProgress } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { ROUTES } from 'shared/constants/ROUTES';
import { autoLogin, selectUserState, userLogin } from 'shared/redux/slicers/user.slicer';

const Impersonation = () => {
  const { token } = useParams() as { token: string };
  const dispatch = useDispatch();
  const asyncDispatchAutoLogin = (token: string) => Promise.resolve(dispatch(autoLogin(token)));
  const history = useHistory();
  useEffect(() => {
    asyncDispatchAutoLogin(token).then(() => history.push(ROUTES.TALENT.DASHBOARD));
  }, [token]);

  return (
    <Box style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <CircularProgress style={{ width: 30, height: 30, marginRight: 10 }} />
      Redirecting...
    </Box>
  );
};

export default Impersonation;
